export enum RoleTypes {
  BUILDER = 'builder',
  DEVELOPER = 'developer',
  ADMIN = 'admin',
}
